import"@lit/reactive-element";import"lit-html";export*from"lit-element/lit-element.js";
//# sourceMappingURL=index.js.map
